<div class="reward-details-form">
  <div class="related-to-product-checkbox">
    <app-checkbox id="is-related-to-product"
                  [formGroup]="formGroup"
                  abstractFormControlName="isRelatedToProduct">
      <span class="related-to-product-description">{{ labels.isRelatedToProduct }}</span>
    </app-checkbox>
  </div>
  <div class="preliminary-details-container">
    <div *ngIf="getControl('isRelatedToProduct').value" class="reward-form-field-grid">
      <div>
        <span class="which-product-label">{{ labels.whichProduct }}<span class="required"> *</span></span>
        <app-search-select [disabled]="rewardId != undefined"
                           [placeholder]="'Search for a product...'"
                           [options]="productList"
                           [control]="getControl('relatedProduct')"
                           (selectionChange)="this.handleChangeProduct($event)">
        </app-search-select>
      </div>
    </div>
    <div *ngIf="!getControl('isRelatedToProduct').value" class="reward-form-field-grid">
      <div>
        <span>{{ labels.rewardTitle }}<span class="required"> *</span></span>
        <app-input [control]="getControl('name')"></app-input>
      </div>
      <div>
        <span>{{ labels.rewardTitleEs }}<span class="required"> *</span></span>
        <app-input [control]="getControl('nameEs')"></app-input>
      </div>
      <div>
        <span>{{ labels.rewardTitlePt }}<span class="required"> *</span></span>
        <app-input [control]="getControl('namePt')"></app-input>
      </div>
    </div>
  </div>
  <div class="preliminary-details-container">
    <div class="reward-form-field-grid">
      <div>
        <span>{{ labels.rewardType }}<span class="required"> *</span></span>
        <app-select [options]="rewardTypes"
                    [optionAccessor]="getObjectLabel"
                    [value]="getControl('rewardType').value"
                    [control]="getControl('rewardType')">
        </app-select>
      </div>
      <div *ngIf="!getControl('isRelatedToProduct').value">
        <span>{{ labels.rewardFamilies }}<span class="required"></span></span>
        <app-select [options]="availableFamilies"
                    [optionAccessor]="getObjectLabel"
                    [value]="selectedFamilies.value"
                    [isMultiSelect]="true"
                    (selectionChange)="filterSeries()"
                    [control]="selectedFamilies">
        </app-select>
      </div>
    </div>
  </div>
  <div class="preliminary-details-container">
    <div class="reward-form-field-small-grid">
      <div>
        <span>{{ labels.discountValue }}<span class="required"> *</span></span>
        <app-input [placeholder]="'00%'"
                   [fieldName]="'discount'"
                   [control]="getControl('rewardDiscount')">
        </app-input>
      </div>
      <div>
        <span>{{ labels.rewardCost }}<span class="required"> *</span></span>
        <app-input [prefixIcon]="'stars'"
                   [placeholder]="'00'"
                   [fieldName]="'reward-form.reward-cost-label'"
                   [control]="getControl('rewardCost')">
        </app-input>
      </div>
      <div>
        <span>{{ labels.rewardCode }}<span class="required"> *</span></span>
        <app-input [placeholder]="'Code'"
                   [control]="getControl('rewardCode')">
        </app-input>
      </div>
      <div>
        <span>{{ labels.redemptionLimit }}</span>
        <app-number-manual-increment [control]="getControl('redemptionLimit')"
                                     [min]="1"
                                     [max]="999"
                                     [fieldName]="'reward-form.redemption-limit-label'"
                                     suffix="times"
                                     resetButtonText="Remove limit"
                                     [errorMessage]="'error-redemption-limit'"
                                     (resetField)="resetRedemptionLimit()">
        </app-number-manual-increment>
      </div>
      <div *ngIf="getControl('rewardType').value === rewardTypes[0]">
        <span>{{ labels.extensionPeriod }}<span class="required"> *</span></span>
        <app-input [suffix]="getExtensionPeriodSuffix()" [control]="getControl('extensionPeriod')"> </app-input>
      </div>
    </div>
  </div>
  <div class="adv-content" *ngIf="!getControl('isRelatedToProduct').value && (!printerSeries || printerSeries.length === 0)">
    <span>{{ labels.rewardFamilyWarning }}</span>
  </div>
  <div class="image" *ngIf="!getControl('isRelatedToProduct').value">
    <span>{{ labels.rewardImage }}</span>
    <app-product-image-upload
      [picture]="getControl('productImage')"
      [modalTitle]="'change-reward-image'"
    ></app-product-image-upload>
  </div>
  <div class="skeleton-container" *ngIf="loading">
    <div class="skeleton-toggle-section">
      <div class="skeleton-line short"></div>
      <div class="skeleton-toggle"></div>
    </div>
    <div class="skeleton-subtext"></div>
    <div class="skeleton-section-title"></div>
    <div class="skeleton-checkbox-row">
      <div class="skeleton-checkbox"></div>
      <div class="skeleton-checkbox"></div>
    </div>
    <div class="skeleton-checkbox-row">
      <div class="skeleton-checkbox"></div>
      <div class="skeleton-checkbox"></div>
    </div>
  </div>
  <app-vip-checkbox-group *ngIf="!loading"
                          [isEnabled]="hasVIPLevelUsersEnabled"
                          [control]="getControl('vipLevels')"
                          [printerSeries]="this.printerSeries"
                          [availableBusinessLevels]="availableBusinessLevels"
                          [availablePrinterSeries]="this.availableFamilies">
  </app-vip-checkbox-group>
</div>
